export default {
    wizardType: "ZENDESK",

    getConnectionParams: (type, model) => ({
        useConnectionProfile: model.get("useConnectionProfile"),
        connectionProfileName: model.get("connectionProfileName"),
        ConnectionUrl: model.get("connectionUrl"),
        AccessToken: model.get("access_token"),
        Mode: model.get("mode") ?? "Automated",
        Username: model.get("username"),
        Password: model.get("password"),
        AuthMode: model.get("authMode"),
        apiToken: model.get("apiToken"),
    }),
};

